import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setPromptsFiltered, resetDisplayCount } from "./guidePromptsSlice";

import './GuidePromptsSearcher.css'
import api from "shared/functions/api";

export const GuidePromptsSearcher = () => {
  const [searchParam] = useState(["prompt"]);
  const [prompts, setPrompts] = useState([]);
  const effectRan = useRef(false);
  const [filterPromptParam, setFilterPromptParam] = useState("All");
  let filterParam = "All";
  let q = ""
  const dispatch = useDispatch();

  const selectArrowDownIcon = {
    backgroundImage: `url(${"static/images/icons/ArrowDownSelect.svg"})`,
  };

  const getPromptsToTry = useCallback(async () => {
    try {
      const jwt = localStorage.getItem("jwt") || "";
      const prompts = await api.fetchPromptsTotry(jwt, "all");
      dispatch(setPromptsFiltered(prompts));
      setPrompts(prompts)
    } catch (error) {
      console.error("Prompt to try error:", error);
    }
  }, []); 

  useEffect(() => {
    if (!effectRan.current) {
      getPromptsToTry();
    } 
    return () => {
      effectRan.current = true;
    }
  });

  const setFilterByTask = (value: string) => {
    filterParam = value;
    q = ""
    search(prompts);
  };

  const setFilterByPrompt = (value: string) => {
    q = value === "All" ? "" : value
    search(prompts);
  };

  const findPrompts = (item: any) => {
    console.log(item)
    return searchParam.some((newItem) => {
      console.log(newItem)
      const value =
        item[newItem].toString().toLowerCase().indexOf(q.toLowerCase()) > -1;
      return value;
    });
  };

  const search = (items: any) => {
    // eslint-disable-next-line array-callback-return
    const itemsTmp = items.filter((item: any) => {
      if (item.category === filterParam && filterPromptParam === "All") {
        return findPrompts(item);
      }
      if (item.prompt === filterPromptParam && item.category === filterParam) {
        return findPrompts(item);
      } else if (filterParam === "All") {
        return findPrompts(item);
      }
    });
  
    console.log('itemsTmp', itemsTmp)
    dispatch(setPromptsFiltered(itemsTmp));
    dispatch(resetDisplayCount());
    return itemsTmp;
  };

  const OptionList = (value: any) => {
    if (
      value.category !== filterParam &&
      filterParam !== "All" &&
      value.category !== "All"
    ) {
      return null;
    }
    if (value.value == q) {
      return (
        <option selected value={value.value}>
          {value.value}
        </option>
      );
    } else {
      return <option value={value.value}>{value.value}</option>;
    }
  };

  return (
    <>
      <div className="select-container">
        <div className="select-container__size">
          <select
            style={{ ...selectArrowDownIcon }}
            onChange={(e) => setFilterByTask(e.target.value)}
            className="custom-select"
            aria-label="Filter By Task"
          >
            <option value="All">All</option>
            <option value="Ask">Ask</option>
            <option value="Analyze">Analyze</option>
            <option value="Create">Create</option>
            <option value="Recap">Recap</option>
          </select>

          <select
            style={{ ...selectArrowDownIcon }}
            onChange={(e) => setFilterByPrompt(e.target.value)}
            className="custom-select"
            aria-label="Filter By Prompt"
          >
            <OptionList category="All" value="All" />
            <OptionList category="Ask" value="Get a KPI for any geography." />
            <OptionList
              category="Ask"
              value="Get a business metric for any geography."
            />
            <OptionList
              category="Ask"
              value="Get a list of countries for any KPI."
            />
            <OptionList category="Ask" value="Get indicators by sector." />
            <OptionList category="Ask" value="Monitor financial metrics." />
            <OptionList category="Analyze" value="Compare actuals vs budget." />
            <OptionList
              category="Analyze"
              value="Compare actuals vs prior year."
            />
            <OptionList
              category="Analyze"
              value="Get KPI results for a period."
            />
            <OptionList
              category="Analyze"
              value="Find impacts of KPI change."
            />
            <OptionList
              category="Analyze"
              value="Compare KPI across different geographies."
            />
            <OptionList
              category="Create"
              value="Create a table with key indicators."
            />
            <OptionList
              category="Create"
              value="Create an email and share the results."
            />
            <OptionList
              category="Create"
              value="Create a table with the top geographies."
            />
            <OptionList category="Recap" value="Be prepared." />
            <OptionList category="Recap" value="Quick recap." />
            <OptionList category="Recap" value="Highlight trends." />
          </select>
        </div>
      </div>
    </>
  );
};